import { SignatureFields } from "./SignatureFields";

type BehavioralDataProps = {
  note: {
    intervention_reaction?: string;
    interventions?: string;
    patient_report?: string;
    patient_task?: string;
  } & Parameters<typeof SignatureFields>[0]["note"];
};

export function BehavioralData({ note }: BehavioralDataProps) {
  return (
    <div className="row">
      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Report or Behavior</label>
          <p>{note.patient_report}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Interventions</label>
          <p>{note.interventions}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Intervention Reaction</label>
          <p>{note.intervention_reaction}</p>
        </div>
      </div>

      <div className="col-12 col-lg-6">
        <div>
          <label className="Label">Patient Task</label>
          <p>{note.patient_task}</p>
        </div>
      </div>

      <SignatureFields note={note} />
    </div>
  );
}
